import React from 'react';
const SvgSheet = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 1024 1024" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M96 32v960h832V256H704V32H96z" />
      <path fill="#FFF" d="M128 64v640h768V256H704V64H128z" />
      <path opacity={0.3} fill="#1B3F63" d="M928 480L704 256h224v224z" />
      <path fill="#769CC2" d="M704 32l224 224H704V32z" />
      <g>
        <path
          fill="#5C7896"
          d="M781.7 518.1V256h-48v262.1h-46v-23.4h-48v94.7h48V566h94v-47.9zm-277.7 0H290V396.8h74V349h-74V231h211v118h-72v47.8h120V231h155v-48H242v383.1h262V585h48v-94.7h-48v27.8z"
        />
      </g>
    </svg>
  );
});
export default SvgSheet;
SvgSheet.iconName = 'sheet';
SvgSheet.displayName = 'SvgSheet';
